import type { ICurrentUser } from '../model/types';

export const canUseTrackedSubjects = (user?: ICurrentUser): boolean => Boolean(user?.canUseTrackedSubjects);
